import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import { Link } from "react-router-dom";
import classNames from "classnames";
import { connect } from "react-redux";
import { Row, Col } from "reactstrap";
import ReactLoading from "react-loading";
import withScrollTo from "../hoc/withScrollTo";
import { getQueryParamsUrl } from "../../helpers/url";
import { Container, Box, Text } from "../PagePaymentResult/styled";
import Header from "../PagePaymentResult/Header";
import Content from "../PagePaymentResult/Content";
import RedirectIfUnauthentic from "../../components/RedirectIfUnauthentic";
import Icon from "./Icon";
import { isFromKickApp } from "../../utils";
import moment from "moment";
import axios from "axios";
import { API_BASE_URL } from "../../constants";
import kredivoDeclined from '../../images/kredivo-payment-declined.png';
import PendingIcon from '../../images/icons/pending.png';
import ErrorIcon from '../../images/kredivo-payment-declined.png';
import SuccessIcon from '../../images/kick-credit-payment-success.jpg';

import { doGetMidtransPaymentDetail, doGetPayment, doFetchProductAddon } from "../../actions/paymentAction";

const NOT_FOUND = "/404";
const HOME_ROUTE = "/";

const getStatusText = status => {
  switch (status) {
    case "VERIFYING_PAYMENT":
    case "VERIFYING_BID":
    case "PENDING":
      return "Waiting your payment confirmation.";
    case "COMPLETE":
    case "COMPLETED":
      return "Your payment has been paid successfully.";
    case "EXPIRED":
      return "Your payment has been refunded.";
    case "EXPIRED":
      return "Your payment has been cancelled.";
    default:
      return "We got something issues when processing your payment.";
  }
};

class PagePaymentSprintasia extends Component {
  constructor(props) {
    super(props);
    const params = Object.assign(
      { orderId: "", statusCode: 0, transactionStatus: "pending" },
      getQueryParamsUrl(props.location.search)
    );
    this.state = {
      params: { ...params },
      data: null,
      pingThreshold: 100, //one hundred times
      pingCount: 0,
      status: "",
      timer: null,
      isFetchSprintasia: true,
      totalAmount: null
    };
    this._handleGoHome = this._handleGoHome.bind(this);
  }
  componentDidMount() {
    const { orderId } = this.state.params || {};
    if (!orderId) {
      this.props.history.replace(NOT_FOUND);
    }
    this.props.getPaymentDetail(this.state.params.orderId);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.paymentDetail.isFetch && !this.props.paymentDetail.isFetch) {
      this.setState({ isFetchSprintasia: false })
      if (this.props.paymentDetail.status_code === 200) {
        const {
          data: {
            offer_amount,
            administration_fee,
            discount,
            subsidy_price,
            ka_courier_price,
            actual_total_amount,
            ka_courier_option,
            expiry,
            user_sell,
            total_price,
            status,
            expired
          }
        } = this.props.paymentDetail
        this.setState({
          offer_amount,
          administration_fee,
          ka_courier_option,
          discount,
          subsidy_price,
          ka_courier_price,
          actual_total_amount,
          expiry,
          user_sell,
          totalAmount: total_price,
          status,
          expired
        })
      }
    }
  }

  _handleGoHome(e) {
    this.props.history.push(HOME_ROUTE);
  }

  _handleOnCompleteTimer = () => {
    const { status } = this.state;
    if (status == 1) {
      this.setState(
        {
          pingCount: 0,
          timer: null
        },
        () => this.getAkulakuDetails()
      );
    }
  };

  getStatusIcon = (paymentStatus, isExpired) => {
    switch (paymentStatus) {
      case 'COMPLETE':
      case 'COMPLETED': return SuccessIcon;
      case 'PENDING':
      case 'VERIFYING_BID': return isExpired ? TimesUpIcon : PendingIcon;
      case 'VERIFYING_PAYMENT': return PendingIcon;
      case 'EXPIRED': return TimesUpIcon;
      default: return ErrorIcon;
    }
  }
  render() {
    return (
      <div id="akulaku-payment-result">
        <div className="akulaku-payment-result-wrapper">
          <div className="icon-wrapper">
          <RedirectIfUnauthentic
              isAuthentic={this.props.dataAuth.isLogged}
              isLoading={this.props.dataAuth.userdata.isFetch}
              from={this.props.location}
            />
            <KickImage src={this.getStatusIcon(this.state.status, this.state.expired)} alt="Buy Now, Pay Later with Akulaku" width={100} style={{ margin: '20px auto' }} />
          </div>
          <div className="header-text-wrapper">
            <p>{getStatusText(this.state.status)}</p>
          </div>
          <div className="message-text-wrapper">
            {this.state.status === 1 ? (
              <p>
                Getting information from Akulaku. Please wait, this take a
                while.
              </p>
            ) : <p>If you have any questions about your order, please contact our
              team by email to{" "}
              <a
                href="mailto:info@kickavenue.com"
                title="Mail to info@kickavenue.com"
              >
                info@kickavenue.com
              </a>
              . Please put your invoice number into your subject email.</p>}
          </div>
          {this.state.message && (
            <div className="referenceId-wrapper">
              <p>referenceId: {this.state.tr_id}</p>
              <p>reason: {this.state.message}</p>
            </div>
          )}
          {!isFromKickApp() &&
            <div className="button-wrapper">
              <div className="back-to-shopping-btn" onClick={() => this._handleGoHome()}><p>BACK TO HOME</p></div>
            </div>
          }
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getMidtransDetail: invoice => dispatch(doGetMidtransPaymentDetail(invoice)),
  getPaymentDetail: invoice => dispatch(doGetPayment(invoice)),
  doFetchProductAddon: (payload) => dispatch(doFetchProductAddon(payload)),
});

const mapStateToProps = ({
  dataPayment: {
    midtrans: { details },
    paymentDetail,
    productAddon
  },
  dataAuth
}) => ({
  dataMidtrans: details,
  paymentDetail,
  productAddon,
  dataAuth
});

const componentConnect = connect(mapStateToProps, mapDispatchToProps);
export default componentConnect(withScrollTo(PagePaymentSprintasia));
